// ScenariosMapView.jsx

import React from 'react';
import ScenariosMapViewInitial from './ScenariosMapViewInitial';
import ScenariosMapViewResults from './ScenariosMapViewResults';

// MODIFIED: This component is now simpler. It only needs to know which map to show
// and the scenarioId for the results map. The 'analysisComplete' prop is no longer needed.
const ScenariosMapView = ({ activeState, scenarioId }) => {
  switch (activeState) {
    case 'original':
      return <ScenariosMapViewInitial />;
    case 'analysis-results':
      // Pass only the scenarioId. The results map component handles its own state logic.
      return <ScenariosMapViewResults scenarioId={scenarioId} />;
    default:
      return <ScenariosMapViewInitial />; // Fallback to the initial map
  }
};

export default ScenariosMapView;